export default __webpack_public_path__ + "static/media/error-system.7d9d6513.svg";